import PropTypes from "prop-types";
import React from "react";
import {
  triggerFetchSimBilling,
  triggerFetchSimBillingCsv,
} from "../../../../redux/actions/index";
import Spinner from "../../../../components/presentationals/Spinner";
import SimBillingTabs from "./components/simBillingTabs";
import SimBillingInsights from "../../insights/simBillingInsights";

export default function SimBilling(props) {

  const {
    simBillingModel: {
      secTilesMasterTxDtos: tilesDto = [],
      isSectionActive = "",
      sectionName,
    },
    timestamp,
    filterValue,
    ...other
  } = props;
  
  let ts = "";
  // const currSelectedTile = props.tabsDto[selectedTab].tileName;
  if (timestamp) {
    ts = timestamp.filter((data) => {
      return data.tilename === `Sim Billing - Primary`;
    });
    ts =
      ts && ts[0] && ts[0].tileTimestamp && ts[0].tileTimestamp?.split(".")[0];
  }
  if (isSectionActive === "Y") {
    if (tilesDto.length) {
      return (
        <div
          className="whitebox wow fadeInUp"
          data-wow-delay=".6s"
          data-wow-duration="0.7s"
          data-cy="whitebox-tiles"
        >
          {/* <div className="subtitlebox">{sectionName}</div> */}
          <div className="subtitlebox">
            <div className="subtitleboxChild">{sectionName}</div>
            <div>{ts}</div>
          </div>
          <div className="row" data-cy="sim-billing">
            {
              tilesDto.map((obj, index) => {
                return (
                  (obj.isTileActive === "Y" ?
                 
                  <SimBillingTabs
                    tileName={obj.tileName}
                    csvName={obj.tileName}
                    url={obj.tileEndPointUrl}
                    csvEndPointUrl={obj.csvEndPointUrl}
                    isCsvActive={obj.isCsvActive}
                    isTileActive={obj.isTileActive}
                    triggerFetchSimBilling={triggerFetchSimBilling}
                    triggerFetchSimBillingCsv={triggerFetchSimBillingCsv}
                    key={index}
                    index={index}
                    section={sectionName}
                    moduleName={props.moduleName}
                    timeStampArr={timestamp}
                    other={{ ...other, filterValue }}
                  />
                  :
                  null)
                );
              })
            }
          </div>
          <SimBillingInsights
            filterValue={filterValue}
            moduleName={props.moduleName}
          />
        </div>
      );
    } else {
      return null;
    }
  } else {
    return null;
  }
}

SimBilling.propTypes = {
  tilesDto: PropTypes.arrayOf(
    PropTypes.shape({
      tileId: PropTypes.number,
      tileName: PropTypes.string,
      isTileActive: PropTypes.string,
      tileEndPointUrl: PropTypes.string,
      moduleSecMasterTransactionDto: PropTypes.any,
    })
  ),
};
